// LocalStorage utility functions with error handling

// Safe localStorage getter
export const getFromStorage = (key) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (e) {
    // localStorage read error silently handled
    return null;
  }
};

// Safe localStorage setter
export const setToStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (e) {
    // localStorage save error handled
    // Try to clear old data if storage is full
    if (e.name === 'QuotaExceededError') {
      try {
        localStorage.removeItem(key);
        localStorage.setItem(key, JSON.stringify(value));
        return true;
      } catch (retryError) {
        // Could not save even after clearing
      }
    }
    return false;
  }
};

// Remove from localStorage
export const removeFromStorage = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (e) {
    // localStorage remove error silently handled
    return false;
  }
};

// Check if cache is valid
export const isCacheValid = (data, duration) => {
  if (!data || !data.timestamp) return false;
  return Date.now() - data.timestamp < duration;
};